import { LOCAL_STORAGE_KEY } from '@/shared/constants/storage';
import { useLocalStorage } from '@/shared/hooks/useLocalStorage';
import { LoginProviderEnum } from '@gorgeous/common/enums/users/login-provider.enum';
import { useEffect, useState } from 'react';

export const useLastLoginProviderStorage = () => {
  const { getItem, setItem } = useLocalStorage();
  const [lastLoginProvider, setLastLoginProviderState] = useState<LoginProviderEnum | null>(null);
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    const value = getItem({ key: LOCAL_STORAGE_KEY.LAST_LOGIN_PROVIDER });
    if (value && Object.values(LoginProviderEnum).includes(value as LoginProviderEnum)) {
      setLastLoginProviderState(value as LoginProviderEnum);
    }
    setIsInitialized(true);
  }, [getItem]);

  const setLastLoginProvider = (provider: LoginProviderEnum) => {
    setItem({ key: LOCAL_STORAGE_KEY.LAST_LOGIN_PROVIDER, value: provider });
    setLastLoginProviderState(provider);
  };

  return { lastLoginProvider, isInitialized, setLastLoginProvider };
};
